import { Observable } from "rxjs";
import { UserModel } from "../models/user.model";
import { InjectionToken } from "@angular/core";
import { BaseResponseModel } from "../models/base-response.model";
import { SelectListItem } from "../models";
import { ResetPasswordModel } from "app/account/model/reset-pwd-model";
import { PullProductCreateModel } from "../models/pull-products.create.model";
import { UserLoginModel } from "app/account/model";

export const USER_AUTHENTICATION_SERVICE = new InjectionToken("user authentication service");

export interface UserAuthInterface {

  //#region Fields

  get authenticatedUser(): UserModel;

  get authenticatedUserPermissions(): Array<string>;

  //#endregion

  //#region Methods

  /**
   * Login using code and password
   * @param Code User code
   * @param Password User password
   */
  login(Code: string, Password: string): Observable<BaseResponseModel<UserModel>>;

  /**
   * Send password reset link
   * @param email Email
   */
  sendPasswordResetLink(email: string): Observable<BaseResponseModel<string>>;

  /**
 * Reset user password
 * @param email Email
 */
  resetUserPassword(model: ResetPasswordModel): Observable<BaseResponseModel<UserModel>>;

  /**
 * Set the authenticated user details
 * @param user User
 */
  setAuthenticatedUser(user: UserModel, rememberMe: boolean): void;

  /**
* Set the authenticated user model details
* @param model  user model
*/
  setRememberCredentials(model: UserLoginModel): void;

  getRememberCredentials(): UserLoginModel | null;

  clearRememberCredentials(): void;

  /**
   * Check whether user has this permission or not
   * @param permissionName Permission name
   */
  hasPermission(permissionName: string): boolean;

  /**
 * Logout user account
 */
  logoutUser();

  getDirecotryMetaDataList(): Observable<BaseResponseModel<SelectListItem>>;
  getMaterialTypeListData(): Observable<BaseResponseModel<any>>;

  pullProductData(saerchModel: PullProductCreateModel): Observable<BaseResponseModel<string>>;

  /**
   * Set user data to BehaviorSubject
   * @param data User data
   */
  setUserData(data: any | null): void;

  /**
   * Get user data from BehaviorSubject
   */
  getUserData(): any | null;

  /**
   * Observable for user data
   */
  userData$: Observable<string | null>;

  clearSession();

  isTokenExpired(token?: string);

  //#endregion
}
